// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1ANph","innerContainer":"_3-ndd","scrollContainer":"_2QEhQ","title":"igkzC"};